import { render } from "./AppPagination.vue?vue&type=template&id=6ce1e815&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=6ce1e815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce1e815"]])

export default __exports__